module.exports = __webpack_public_path__ + "img/logo2.e5420a31.png";